var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { column, moneyColumn, datetimeColumn, } from '../../hooks/useColumns';
import { useOrderListItem, toOptions, usePaymentTimingForPriceVersion, } from '../../hooks/useListItem';
import MaterialTable from '../MaterialTable';
import OrderPriceComponent from './OrderPrice';
import { Grid, useTheme } from '@mui/material';
import FullScreenDialog from '../molecules/FullScreenDialog';
import { DetailsIcon } from '../atoms/Icons';
import LabeledGridItem from '../atoms/LabeledGridItem';
import { camelize } from '../../utils/camelize';
import { formatMoneyAmount } from '../../utils/format';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  table {\n    tr {\n      th,\n      td {\n        &:nth-of-type(8) {\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  ", " {\n    table {\n      tr {\n        th,\n        td {\n          &:nth-of-type(n + 3):nth-of-type(-n + 6) {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  table {\n    tr {\n      th,\n      td {\n        &:nth-of-type(8) {\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  ", " {\n    table {\n      tr {\n        th,\n        td {\n          &:nth-of-type(n + 3):nth-of-type(-n + 6) {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var $smallSizeQuery = _a.$smallSizeQuery;
    return $smallSizeQuery;
});
var OrderPriceWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  table {\n    width: 100%;\n  }\n"], ["\n  table {\n    width: 100%;\n  }\n"])));
var OrderPricesTable = function (_a) {
    var orderPrices = _a.orderPrices, _b = _a.isUSRoaster, isUSRoaster = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var theme = useTheme();
    var _c = React.useState(), shownOrderPrice = _c[0], setShownOrderPrice = _c[1];
    var deliveryMethodItems = useOrderListItem().deliveryMethodItems;
    var paymentTimingForPriceVersion = usePaymentTimingForPriceVersion();
    var priceTypeOptions = React.useMemo(function () {
        return ['simulation', 'fixed'].reduce(function (options, type) {
            options[type] = t("params.orderPrice.priceTypes.".concat(type));
            return options;
        }, {});
    }, [t]);
    var renderPaymentTiming = React.useCallback(function (orderPrice) {
        return paymentTimingForPriceVersion(orderPrice.order, orderPrice.paymentTiming);
    }, [paymentTimingForPriceVersion]);
    var columns = React.useMemo(function () { return [
        column('priceType', {
            lookup: priceTypeOptions,
        }),
        column('paymentTiming', {
            title: t('params.order.paymentTiming'),
            render: renderPaymentTiming,
        }),
        column('deliveryMethod', {
            title: t('params.order.deliveryMethod'),
            lookup: toOptions(deliveryMethodItems),
        }),
        moneyColumn('subTotal', { getCurrency: getCurrency }),
        moneyColumn('discount', { getCurrency: getCurrency }),
        moneyColumn('total', { getCurrency: getCurrency }),
        datetimeColumn('createdAt', { defaultSort: 'desc' }),
    ]; }, [deliveryMethodItems, priceTypeOptions, t, renderPaymentTiming]);
    var actions = React.useMemo(function () { return [
        {
            icon: function () { return React.createElement(DetailsIcon, null); },
            onClick: function (e, orderPrice) {
                e.preventDefault();
                setShownOrderPrice(orderPrice);
            },
            tooltip: t('buttons.priceDetail'),
        },
    ]; }, [t]);
    // TODO: 同一のデータが何度もrenderされたときに何故か無限ループに陥るのでdepsを空にしている…うーん…
    var table = React.useMemo(function () { return (React.createElement(MaterialTable, { model: "orderPrice", title: t('orderPrices'), columns: columns, actions: actions, data: orderPrices })); }, []);
    var moneyFormat = React.useCallback(function (value) {
        if (!shownOrderPrice)
            return '';
        return formatMoneyAmount(value, shownOrderPrice.currency);
    }, [shownOrderPrice]);
    var valueGridProps = React.useMemo(function () { return ({
        sx: function (theme) {
            var _a;
            return (_a = {
                    display: 'flex',
                    alignItems: 'center'
                },
                _a[theme.breakpoints.down('sm')] = {
                    justifyContent: 'end',
                },
                _a);
        },
    }); }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { "$smallSizeQuery": theme.breakpoints.down('sm') }, table),
        React.createElement(FullScreenDialog, { title: t('buttons.priceDetail'), open: Boolean(shownOrderPrice), onClose: function () { return setShownOrderPrice(undefined); } }, shownOrderPrice && (React.createElement(OrderPriceWrapper, null,
            React.createElement(Grid, { container: true, sx: { marginBottom: 2 } },
                React.createElement(LabeledGridItem, { label: t('params.orderPrice.subTotal'), value: moneyFormat(shownOrderPrice.subTotal), valueGridProps: valueGridProps }),
                React.createElement(LabeledGridItem, { label: t('params.orderPrice.discount'), value: moneyFormat(shownOrderPrice.discount), valueGridProps: valueGridProps }),
                React.createElement(LabeledGridItem, { label: t('params.orderPrice.total'), value: moneyFormat(shownOrderPrice.total), valueGridProps: valueGridProps }),
                React.createElement(LabeledGridItem, { label: t('params.order.deliveryMethod'), value: t("params.order.deliveryMethods.".concat(camelize(shownOrderPrice.deliveryMethod))), valueGridProps: valueGridProps }),
                React.createElement(LabeledGridItem, { label: t('params.order.paymentTiming'), value: t("params.order.paymentTimings.".concat(camelize(shownOrderPrice.paymentTiming))), valueGridProps: valueGridProps })),
            React.createElement(OrderPriceComponent, { orderPriceItemType: shownOrderPrice.order.isTypicaStockOrder
                    ? 'TypicaStockItem'
                    : 'Offer', offers: __spreadArray(__spreadArray([], shownOrderPrice.order.items.map(function (_a) {
                    var offer = _a.offer;
                    return offer;
                }), true), shownOrderPrice.order.bids.map(function (_a) {
                    var offer = _a.offer;
                    return offer;
                }), true), orderPrice: shownOrderPrice, isUSRoaster: isUSRoaster }))))));
};
var getCurrency = function (orderPrice) { return orderPrice.currency; };
export default OrderPricesTable;
var templateObject_1, templateObject_2;
